// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bigFont":"bigFont-2ZjaSc0m","smallFont":"smallFont-Z_OfA44W","text":"text-20BABGxP","shortText":"shortText-3TCtWa_g"};